export const getDate = (data: string, withTime: boolean = false): string => {
  const date: Date = new Date(data);

  const day: number = date.getDate();
  const month: number = date.getMonth() + 1;
  const year: number = date.getFullYear();

  let result: string = `${day < 10 ? '0' : ''}${day}.${month < 10 ? '0' : ''}${month}.${year}`;

  if (withTime) {
    const hours: number = date.getHours();
    const minutes: number = date.getMinutes();
    result += ` ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
  }

  return result;
};
